import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { Dossier } from '../models/dossiers/dossier';
import { Fichier } from '../models/dossiers/fichier';

const resource = 'Fichiers'


export default class FichiersResource {

  public async downloadFile(fileId: string) : Promise<any> {
    const response = await api.get(`${resource}/askDownload?fileId=${fileId}`)
    return response.data
  }
}